export type TextAlignment = "left" | "centre" | "right" | undefined;

export function textAlignmentToCssTextAlignValue(alignment: TextAlignment) {
    if (alignment === "centre") return "center";
    return alignment;
}
